import { DialogContent } from "@material-ui/core";
import styled from "styled-components";

export const CustomErrorDialogContent = styled(DialogContent)`
  padding: 5px 0 !important;
  display: grid;
  grid-gap: 20px;
`;
